import extendWith from 'lodash/extendWith';

export function extendWithPrice(dest: any, ...args: any[]) {
  if (!dest) {
    dest = {};
  }

  dest.price = dest.price || 0;
  dest.priceWithoutVat = dest.priceWithoutVat || 0;

  args.forEach((item, i) => {
    if (!item) {
      args[i] = {};
    }
  });

  return extendWith(dest, ...args, (value, src, key) => {
    if ((key === 'price' || key === 'priceWithoutVat') && src) {
      return src;
    }
    return value;
  });
}

export function extendPrintingPicturesWithPrice(imagesForPrinting: any[]) {
  return imagesForPrinting.map(picture => {
    picture.price = picture.price || 0;
    picture.priceWithoutVat = picture.priceWithoutVat || 0;
    return picture;
  });
}

export function sumPrices(a: { price?: number, priceWithoutVat: number },
                          b: { price?: number, priceWithoutVat: number }) {
  a = a || { price: 0, priceWithoutVat: 0 };
  b = b || { price: 0, priceWithoutVat: 0 };

  a.price += b.price || 0;
  a.priceWithoutVat += b.priceWithoutVat || 0;
}
